import React from "react";
import { Flex, Box } from "@chakra-ui/react";
import { Caption } from "src/atoms/typography";
import Slider from "src/components/Slider";
import time from "src/utils/time";

export default class AudioPlayer extends React.Component {
  componentDidMount() {
    this.frameRequestId = requestAnimationFrame(this.updateSelf);
  }
  componentWillUnmount() {
    window.cancelAnimationFrame(this.frameRequestId);
  }
  updateSelf = () => {
    this.forceUpdate();
    this.frameRequestId = requestAnimationFrame(this.updateSelf);
  };

  onChange = (value) => this.props.onSeek(value);
  onChangeCommitted = (value) => this.props.onSeekCommitted(value);

  render() {
    const { onStop, getCurrentTime, getDuration, width } = this.props;

    return (
      <Flex width={width} alignItems="center">
        <Box
          onClick={onStop}
          p="6px"
          bg="primary"
          mr="12px"
          borderRadius="2px"
        />
        <Flex alignItems="center" flex="1 1 auto">
          <Slider
            value={getCurrentTime()}
            min={0}
            max={getDuration() || 0}
            step={getDuration() / 100}
            onChange={this.onChange}
            onChangeEnd={this.onChangeCommitted}
          />
        </Flex>
        <Caption
          width="30px"
          color="mediumEmphasis"
          ml="16px"
          whiteSpace="nowrap"
        >
          {time.duration(getCurrentTime() * 1000).format("mm:ss")}
        </Caption>
      </Flex>
    );
  }
}
